import { render, staticRenderFns } from "./DeleteGroupBuySetting.vue?vue&type=template&id=05d66142"
import script from "./DeleteGroupBuySetting.vue?vue&type=script&lang=js"
export * from "./DeleteGroupBuySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports